module.exports = __webpack_public_path__ + "img/New SSB Logo.0b5e48d2.png";